<template>
  <div class="features">
    <v-container>
      <v-row>
        <v-col cols="12" sm="6" md="4" lg="4">
          <div class="parent d-flex align-center justify-center flex-column flex-sm-row">
            <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="shipping-fast" role="img"
              xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512"
              class="svg-inline--fa fa-shipping-fast fa-w-20 fa-3x mr-5 mb-5 mb-sm-0" style="width: 40px">
              <path fill="currentColor"
                d="M624 352h-16V243.9c0-12.7-5.1-24.9-14.1-33.9L494 110.1c-9-9-21.2-14.1-33.9-14.1H416V48c0-26.5-21.5-48-48-48H112C85.5 0 64 21.5 64 48v48H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h272c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H40c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h208c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h208c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H64v128c0 53 43 96 96 96s96-43 96-96h128c0 53 43 96 96 96s96-43 96-96h48c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM160 464c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm320 0c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm80-208H416V144h44.1l99.9 99.9V256z"
                class=""></path>
            </svg>
            <span style="font-size:20px;">Free shipping & Returns</span>
          </div>
        </v-col>
        <v-col cols="12" sm="6" md="4" lg="4">
          <div class="parent d-flex align-center justify-center second flex-column flex-sm-row">
            <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="award" role="img"
              xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"
              class="svg-inline--fa fa-award fa-w-12 fa-3x mr-5  mb-5 mb-sm-0" style="width: 40px">
              <path fill="currentColor"
                d="M97.12 362.63c-8.69-8.69-4.16-6.24-25.12-11.85-9.51-2.55-17.87-7.45-25.43-13.32L1.2 448.7c-4.39 10.77 3.81 22.47 15.43 22.03l52.69-2.01L105.56 507c8 8.44 22.04 5.81 26.43-4.96l52.05-127.62c-10.84 6.04-22.87 9.58-35.31 9.58-19.5 0-37.82-7.59-51.61-21.37zM382.8 448.7l-45.37-111.24c-7.56 5.88-15.92 10.77-25.43 13.32-21.07 5.64-16.45 3.18-25.12 11.85-13.79 13.78-32.12 21.37-51.62 21.37-12.44 0-24.47-3.55-35.31-9.58L252 502.04c4.39 10.77 18.44 13.4 26.43 4.96l36.25-38.28 52.69 2.01c11.62.44 19.82-11.27 15.43-22.03zM263 340c15.28-15.55 17.03-14.21 38.79-20.14 13.89-3.79 24.75-14.84 28.47-28.98 7.48-28.4 5.54-24.97 25.95-45.75 10.17-10.35 14.14-25.44 10.42-39.58-7.47-28.38-7.48-24.42 0-52.83 3.72-14.14-.25-29.23-10.42-39.58-20.41-20.78-18.47-17.36-25.95-45.75-3.72-14.14-14.58-25.19-28.47-28.98-27.88-7.61-24.52-5.62-44.95-26.41-10.17-10.35-25-14.4-38.89-10.61-27.87 7.6-23.98 7.61-51.9 0-13.89-3.79-28.72.25-38.89 10.61-20.41 20.78-17.05 18.8-44.94 26.41-13.89 3.79-24.75 14.84-28.47 28.98-7.47 28.39-5.54 24.97-25.95 45.75-10.17 10.35-14.15 25.44-10.42 39.58 7.47 28.36 7.48 24.4 0 52.82-3.72 14.14.25 29.23 10.42 39.59 20.41 20.78 18.47 17.35 25.95 45.75 3.72 14.14 14.58 25.19 28.47 28.98C104.6 325.96 106.27 325 121 340c13.23 13.47 33.84 15.88 49.74 5.82a39.676 39.676 0 0 1 42.53 0c15.89 10.06 36.5 7.65 49.73-5.82zM97.66 175.96c0-53.03 42.24-96.02 94.34-96.02s94.34 42.99 94.34 96.02-42.24 96.02-94.34 96.02-94.34-42.99-94.34-96.02z"
                class=""></path>
            </svg>
            <span style="font-size:20px;">Lowest Price Guarantee</span>
          </div>
        </v-col>
        <v-col cols="12" sm="6" md="4" lg="4">
          <div class="parent d-flex align-center justify-center flex-column flex-sm-row">
            <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="trophy-alt" role="img"
              xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"
              class="svg-inline--fa fa-trophy-alt fa-w-18 fa-3x mr-5  mb-5 mb-sm-0" style="width: 40px">
              <path fill="currentColor"
                d="M552 64H448V24c0-13.3-10.7-24-24-24H152c-13.3 0-24 10.7-24 24v40H24C10.7 64 0 74.7 0 88v56c0 66.5 77.9 131.7 171.9 142.4C203.3 338.5 240 360 240 360v72h-48c-35.3 0-64 20.7-64 56v12c0 6.6 5.4 12 12 12h296c6.6 0 12-5.4 12-12v-12c0-35.3-28.7-56-64-56h-48v-72s36.7-21.5 68.1-73.6C498.4 275.6 576 210.3 576 144V88c0-13.3-10.7-24-24-24zM64 144v-16h64.2c1 32.6 5.8 61.2 12.8 86.2-47.5-16.4-77-49.9-77-70.2zm448 0c0 20.2-29.4 53.8-77 70.2 7-25 11.8-53.6 12.8-86.2H512v16zm-127.3 4.7l-39.6 38.6 9.4 54.6c1.7 9.8-8.7 17.2-17.4 12.6l-49-25.8-49 25.8c-8.8 4.6-19.1-2.9-17.4-12.6l9.4-54.6-39.6-38.6c-7.1-6.9-3.2-19 6.7-20.5l54.8-8 24.5-49.6c4.4-8.9 17.1-8.9 21.5 0l24.5 49.6 54.8 8c9.6 1.5 13.5 13.6 6.4 20.5z"
                class=""></path>
            </svg>

            <span style="font-size:20px;">Longest Warranties Offer</span>
          </div>
        </v-col>
      </v-row></v-container>
  </div>
</template>

<style lang="scss">
.features {
  .second {
    position: relative;

    &::before {
      content: "";
      position: absolute;
      background-color: rgb(102, 100, 100);
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      width: 1px;
      height: 70%;
    }

    &::after {
      content: "";
      position: absolute;
      background-color: rgb(102, 100, 100);
      right: 0;
      top: 50%;
      transform: translateY(-50%);
      width: 1px;
      height: 70%;
    }
  }
}

// media queries
@media (max-width: 700px) {
  .features {
    .second {
      &::before, &::after {
        display: none;
      }
    }
  }
}
</style>
